// Vendor libraries
import { createAction, props } from '@ngrx/store';
// Types / Interfaces
import { APP_STATE_RESET_TO_SYSTEM_DEFAULT, APP_STATE_RESET_TO_USER_DEFAULT, APP_STATE_SET_DESERIALIZED_APP_STATE, } from 'NewAngular/state/app-state/app-state.action-types';
export const setAppStateSliceKey = createAction('[App State] Set State Slice Key', props());
export const setSystemDefaultState = createAction('[App State] Set System Default State', props());
export const setUserDefaultState = createAction('[App State] Set User Default State', props());
export const resetToSystemDefault = createAction(APP_STATE_RESET_TO_SYSTEM_DEFAULT);
export const resetToUserDefault = createAction(APP_STATE_RESET_TO_USER_DEFAULT);
export const setDeserializedAppState = createAction(APP_STATE_SET_DESERIALIZED_APP_STATE, props());
